const parse = (hex) => {
  let h = (hex || "").trim().replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  if (!/^[0-9a-fA-F]{6}$/.test(h)) return null;
  return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
};

const toHex = (rgb) => "#" + rgb.map((v) => Math.round(Math.max(0, Math.min(255, v))).toString(16).padStart(2, "0")).join("");

const luminance = (rgb) => {
  const [r, g, b] = rgb.map((v) => { const c = v / 255; return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4; });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

export const isHex = (hex) => !!parse(hex);

export const contrastRatio = (a, b) => {
  const x = parse(a), y = parse(b);
  if (!x || !y) return null;
  const [l1, l2] = [luminance(x), luminance(y)].sort((m, n) => n - m);
  return (l1 + 0.05) / (l2 + 0.05);
};

export const readableOn = (bg) => {
  const rgb = parse(bg);
  if (!rgb) return "#ffffff";
  return contrastRatio("#000000", bg) >= contrastRatio("#ffffff", bg) ? "#16243b" : "#ffffff";
};

export const suggestReadable = (fg, bg, target = 4.5) => {
  const f = parse(fg), b = parse(bg);
  if (!f || !b) return null;
  const toward = luminance(b) > 0.4 ? [0, 0, 0] : [255, 255, 255];
  for (let t = 0.05; t <= 1.0001; t += 0.05) {
    const c = toHex(f.map((v, i) => v + (toward[i] - v) * t));
    if (contrastRatio(c, bg) >= target) return c;
  }
  return toHex(toward);
};
